export const ActionTypes = {
  SET_EMPLOYEES: "SET_EMPLOYEES"
}